import mainConfig from "./config/main.config";
import { HEALTH, V1 } from "./constants";
import { v4 as uuid } from "uuid";

export const PING_URL = `${mainConfig.getConfig(process.env.REACT_APP_ENVIRONMENT)?.registrationApiUrl}${V1}${HEALTH}?u=${uuid()}`;
